import React from 'react'
import HeroSection from './HeroSection'
import NewHeroSecton from './NewHeroSecton'
import { About } from '../../assets'
import AboutSection from './AboutSection'
import HourglassTimer from './HourglassTimer'
import PremiumOfferSection from './PremiumOfferSection '
import LogoSlider from './LogoSlider'
import SalesOrganaizaton from './SalesOrganaizaton'
import DontJoin from './DontJoin'
import AnimatedGraphic from './AnimatedGraphic'
import WhatULearn from './WhatULearn'
import VideoTestimonials from './VideoTestimonials'
import CoachSection from './CoachSection'
import MasterclassGallery from './MasterClassGallery'
import PromiseSection from './PromiseSection'
import FAQs from './FAQs'
import Bonus from './Bonus'
import { Box } from '@mui/system'


const index = () => {
  return (
    <Box sx={{background:'#000'}}>
        {/* <HeroSection/> */}
        <NewHeroSecton/>
        <AboutSection/>
        <PremiumOfferSection/>
        {/* <LogoSlider/> */}
        <SalesOrganaizaton/>
        <DontJoin/>
        {/* <AnimatedGraphic/> */}
        <WhatULearn/>
        <Bonus/>
        <VideoTestimonials/>
        <CoachSection/>
        <MasterclassGallery/>
        <PromiseSection/>
        <FAQs/>
    </Box >
  )
}

export default index